export default __webpack_public_path__ + "static/Entenda0142-dc52e603939647f456189ee1d17d140f.jpg";